<app-popin-container>
  <div class="flex flex-col gap-y-5 py-2.5">
    @if (data.title; as title) {
      <app-title [title]="title" size="h2" />
    }
    @if (data.content; as content) {
      <div [innerHTML]="content" class="prose" handleHtmlLinks></div>
    }
  </div>
</app-popin-container>
